import {
    Breadcrumb,
    Button,
    Card,
    DatePicker,
    Form,
    Input,
    Modal,
    Select,
  } from "antd";
  import { ReactComponent as TitleIcon } from "../../../../assests/images/settingsBreadCum.svg";
  import { useTranslation } from "react-i18next";
  import { useNavigate } from "react-router";
  import { useCallback, useEffect, useState } from "react";
  import AccountCard from "../../../../components/account-card";
  import AccountSelectedCard from "../../../../components/account-selected-card";
  import { useSelector } from "react-redux";
  import {
    accountListSelector,
    selectedAccountSelector,
  } from "../../../../store/selectors/app.selector";
  import ChequeService from "../../../../services/cheque.service";
  import AccountDisplay from "../../../../components/account-display";
  import CommonOtp from "../../../../components/otp";
  import { CONFIG } from "../../../../environment";
  import {
    allowOnlyAlphaNumerics,
    allowOnlyAlphaNumericsShouldNotStartWithSpace,
    amountFormat,
  } from "../../../../services/common.service";
  import moment from "moment";
  import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";
  
  export default function StopChequeRequest() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [stage, setStage] = useState(1);
    const [form] = Form.useForm();
    const selectedAccount = useSelector(selectedAccountSelector);
    const [formValues, setFormValues] = useState([]);
    const [responseDetails, setResponseDetails] = useState({});
    const [reasonList, setReasonList] = useState([]);
    const [reqType, setReqType] = useState("Individual Cheque");
    const [otp, setOtp] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);
  
    useEffect(() => {
      getStopchequeReasonList();
    }, []);
  
    useEffect(() => {
      form.setFieldsValue({
        requestType: reqType,
      });
    }, [reqType]);
  
    const getStopchequeReasonList = useCallback(async () => {
      try {
        const response = await ChequeService.getStopchequeReasonList();
        if (response.status === 200) {
          setReasonList(response.data["data"] || []);
        }
      } catch (error) {
        console.error(error);
      }
    }, []);
  
    const stopChequeVerify = useCallback(
      async (values) => {
        try {
          const noOfCheques =
            values?.endChequeNumber - values.startChequeNumber + 1;
          const reqParams = {
            brnCode: selectedAccount?.branchId,
            srcAccount: selectedAccount?.accountNo,
            startChequeNumber: values?.startChequeNumber || values?.chequeNo,
            endChequeNumber: values?.endChequeNumber || values?.chequeNo,
            stopPaymentType: values.requestType,
            requestType: values.requestType,
            effectiveDate: values.effectiveDate,
            reason: values.reason,
            noOfLeaves:
              values.requestType === "Individual Cheque" ? 1 : noOfCheques,
            remarks: values.remarks,
          };
          setFormValues(reqParams);
  
          const response = await ChequeService.stopChequeverify(reqParams);
          if (response.status === 200) {
            if (response.data["data"]["otpEnable"]) {
              setStage(2);
            } else {
              stopChequeConfirm({
                ...reqParams,
                ...{ otp: CONFIG.DEFAULT_OTP },
              });
            }
          }
        } catch (error) {}
      },
      [selectedAccount]
    );
    const stopChequeConfirm = useCallback(async (values) => {
      try {
        const reqParams = {
          ...values,
        };
        const response = await ChequeService.stopChequeConfirm(reqParams);
        if (response.status === 200) {
          setResponseDetails(response.data["data"]);
          setSuccessVisible(true);
        }
      } catch (error) {}
    }, []);
  
    const handleResendOtp = useCallback(async (values) => {
      try {
        const response = await ChequeService.stopChequeverify(values);
        if (response.status === 200) {
        }
      } catch (error) {}
    }, []);
  
    function renderSwitch() {
      switch (stage) {
        case 1:
          return renderForm();
  
        case 2:
          return (
            <CommonOtp
              otp={otp}
              setOtp={setOtp}
              onConfirm={(values) =>
                stopChequeConfirm({ ...values, ...formValues })
              }
              handleResendOtp={() => handleResendOtp(formValues)}
              cancelTransaction={() => {
                navigate("/request");
              }}
            />
          );
  
        default:
          return renderForm();
      }
    }
  
    function renderForm() {
      return (
        <>
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <AccountDisplay type="image" />
              </div>
            </div>
          </div>
          <Form form={form} layout="vertical" onFinish={stopChequeVerify}>
            <div className="row">
              {" "}
              <div>
                {" "}
                <Form.Item
                  label="Request Type"
                  name="requestType"
                  rules={[
                    {
                      required: true,
                      message: "Request Type is required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Request Type"
                    size="large"
                    optionLabelProp={"value"}
                    onChange={(value) => setReqType(value)}
                    dropdownMatchSelectWidth={false}
                  >
                    <Select.Option value={"Individual Cheque"}>
                      Individual Cheque
                    </Select.Option>
                    <Select.Option value={"Range of Cheques"}>
                      Range of Cheques
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
              {reqType === "Individual Cheque" ? (
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  {" "}
                  <Form.Item
                    label={t("pages.cheques.cheque_number", {
                      defaultValue: "Cheque Number",
                    })}
                    name="chequeNo"
                    rules={[
                      { required: true, message: "Cheque Number is required" },
                    ]}
                  >
                    <Input
                      placeholder={t("pages.cheques.cheque_number", {
                        defaultValue: "Cheque Number",
                      })}
                      size="large"
                      onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                      maxLength={15}
                    />
                  </Form.Item>
                </div>
              ) : (
                <>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="Start Cheque Number"
                      name="startChequeNumber"
                      rules={[
                        {
                          required: true,
                          message: "Start Cheque Number is required",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Start Cheque Number"
                        size="large"
                        onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                        maxLength={15}
                      />
                    </Form.Item>{" "}
                  </div>{" "}
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <Form.Item
                      label="End Cheque Number"
                      name="endChequeNumber"
                      rules={[
                        {
                          required: true,
                          message: "End Cheque Number is required",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const startChequeNumber =
                              getFieldValue("startChequeNumber");
  
                            if (startChequeNumber && value) {
                              const startNumber = parseInt(startChequeNumber);
                              const endNumber = parseInt(value);
  
                              if (startNumber >= endNumber) {
                                return Promise.reject(
                                  new Error(
                                    "End Cheque Number should be greater than Start Cheque Number"
                                  )
                                );
                              }
                            }
  
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Input
                        placeholder="End Cheque Number"
                        size="large"
                        onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                        maxLength={15}
                      />
                    </Form.Item>
                  </div>
                </>
              )}
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("pages.cheques.reason", {
                    defaultValue: "Reason",
                  })}
                  name="reason"
                  rules={[
                    {
                      required: true,
                      message: t("pages.cheques.reason_req", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.cheques.reason", {
                      defaultValue: "Reason",
                    })}
                    size="large"
                  >
                    {reasonList.map((option, idx) => (
                      <Select.Option key={idx} value={option?.reason}>
                        {option?.reason}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                {" "}
                <Form.Item
                  label="Effective Date"
                  name="effectiveDate"
                  rules={[
                    {
                      required: true,
                      message: "Effective Date is required",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="DD-MM-YYYY"
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    className="col-12"
                    style={{ borderRadius: "5px" }}
                    size="large"
                    disabledDate={(current) =>
                      current.isBefore(moment().subtract(1, "days"))
                    }
                    showNow={false}
                  />
                </Form.Item>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                {" "}
                <Form.Item
                  label={t("common.remarks", { defaultValue: "Reason" })}
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.remark_require", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={30}
                    placeholder={t("common.remarks", { defaultValue: "Reason" })}
                    onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="d-flex justify-content-end  mt-3">
              {" "}
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                className="primary-btn"
              >
                {t("buttons.submit_btn", {
                  defaultValue: "Submit",
                })}
              </Button>{" "}
            </div>
          </Form>
        </>
      );
    }
  
    return (
      <>
        <div>
            <Breadcrumb separator=">">
              {/* <Breadcrumb.Item>
                <span onClick={() => navigate("/dashboard")}>
                  {t("navigation.home", {
                    defaultValue: "Home",
                  })}
                </span>
              </Breadcrumb.Item> */}
              {/* <Breadcrumb.Item>
                <span onClick={() => navigate("/settings")}>
                  {t("navigation.other", {
                    defaultValue: "Other Services",
                  })}
                </span>
              </Breadcrumb.Item> */}
              <Breadcrumb.Item>
                <span onClick={() => navigate("/request")}> Service Request</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>
                  {t("pages.cheques.stop_cheque", {
                    defaultValue: "Stop Cheque",
                  })}
                </span>
              </Breadcrumb.Item>
            </Breadcrumb>
          <Card size="small" className="mb-1 text-center breadcrumb-title-card">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
                {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
                <h3 className="title mb-0">
                  {t("pages.cheques.stop_cheque", {
                    defaultValue: "Stop Cheque",
                  })}
                </h3>
              </div>
            </div>
          </Card>
  
          <div className="row d-flex justify-content-between">
            <div className=" d-flex justify-content-between">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
                <Card
                  className="application-card"
                  
                >
                  {stage === 1 ? <AccountCard /> : <AccountSelectedCard />}
                </Card>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <Card className="payee-render-section application-card">
                  {renderSwitch()}
                </Card>
              </div>
            </div>
          </div>
        </div>{" "}
        <Modal
          title={""}
          open={successVisible}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={true}
          // className="custom-error-modal"
        >
          <div style={{ margin: "0 auto" }} align="center">
            <TickIcon height={65} />
            <h4 className="mb-3 mt-2">
              {" "}
              {t("common.success", {
                defaultValue: "Success",
              })}
            </h4>
            <p>{responseDetails.message}</p>
  
            <div align="center">
              <Button
                size="large"
                style={{ width: 130 }}
                onClick={() => {
                  setSuccessVisible(false);
                  navigate("/request");
                }}
                type="primary"
              >
                {t("buttons.okay_btn", {
                  defaultValue: "Okay",
                })}
              </Button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
  